import { FirebaseError } from '@firebase/util';

export default function isFirebaseError(err): err is FirebaseError {
  return err.code && err.code.startsWith('auth/');
}
